export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  WARNING: 'ALERT_WARNING',
  CLEAR: 'ALERT_CLEAR',
};
